import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import type { AppState } from 'types/app';
import type { CustomerInfo } from 'types/balder';
import { clearCartLocalStorage } from 'helpers/CartUtils';
import useMartyContext from 'hooks/useMartyContext';

import css from 'styles/components/account/accountHeader.scss';

interface AccountHeaderProps {
  title: string;
  account: {
    customerInfo?: CustomerInfo;
  };
  showCustomerEmail: boolean;
  showFirstName: boolean;
  customizedMessage?: string;
  firstName?: string;
  prime?: boolean;
}

export const AccountHeader = ({
  title,
  account: { customerInfo } = {},
  showCustomerEmail = true,
  showFirstName = false,
  customizedMessage,
  firstName,
  prime
}: AccountHeaderProps) => {
  const {
    testId,
    marketplace: {
      dataMaskPiiElements,
      account: { showLogoutLink }
    }
  } = useMartyContext();

  const customerEmail = customerInfo?.email;

  const makeMessage = () => {
    if (customizedMessage) {
      return (
        <div data-cs-mask={dataMaskPiiElements} data-test-id={testId('accountGreeting')}>
          {customizedMessage}
          {customerEmail}
        </div>
      );
    }

    if (showCustomerEmail && customerEmail) {
      return (
        <div data-cs-mask={dataMaskPiiElements} data-test-id={testId('accountGreeting')}>
          You are logged in as {customerEmail}
          {showLogoutLink && (
            <>
              {' '}
              <Link to="/logout" onClick={clearCartLocalStorage} className={css.logout} data-test-id={testId('logoutLink')}>
                Logout
              </Link>
            </>
          )}
        </div>
      );
    }

    if (!showCustomerEmail && showFirstName) {
      return (
        <div data-cs-mask={dataMaskPiiElements} data-test-id={testId('accountGreeting')}>
          You are logged in as {firstName}
        </div>
      );
    }

    return null;
  };

  return (
    <div className={css.accountHeader}>
      <h1 data-test-id={testId('heading')}>
        {title}
        {prime && <span className={css.primeBadge} aria-label="Amazon Prime badge" />}
      </h1>

      {makeMessage()}
    </div>
  );
};

AccountHeader.defaultProps = {
  showCustomerEmail: true,
  showFirstName: false
};

export function mapStateToProps(state: AppState) {
  const { account, holmes } = state;
  const firstName = holmes ? holmes.firstName : '' || '';
  return {
    account,
    firstName
  };
}

export default connect(mapStateToProps)(AccountHeader);
